import {validate as isValidUUID} from "uuid";
import {CONSTANTS} from "./constants";

const SESSION_ID = 'session-id';
const APP_GUID = 'app-guid';

export const handleSessionId = (response) => {
  const sessionId = response.headers['x-psb-sid'] || null;
  const companyId = response.headers['x-psb-cid'] || null;
  const userId = response.headers['x-psb-uid'] || null;
  const redirectTo = response.headers['x-redirect-to'] || null;

  if (redirectTo && redirectTo?.length > 0 && !(window.location.href.indexOf(redirectTo) > -1)) {
    let urlParts = window.location.href.split('#/cx/');
    let resolvedUrl = redirectTo;
    if (urlParts?.length > 1) {
      resolvedUrl = (resolvedUrl + '#/cx/' + urlParts[1]);
    }
    window.location.href = resolvedUrl;
  }

  if (sessionId) {
    setAppCookie(CONSTANTS.PSB_SID, sessionId);
  }
  if (userId) {
    setAppCookie(CONSTANTS.PSB_UID, userId);
  }
  if (companyId) {
    setAppCookie(CONSTANTS.PSB_CID, companyId);
  }
}

export const setAppCookie = (cookieName, cookieValue) => {
  const d = new Date();
  d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

export const getCookie = (cookieName) => {
  let name = cookieName + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const getAppSessionCookie = () => {
  return getCookie(SESSION_ID);
}

export const setAppGuidCookie = (guid) => {
  if (!isValidUUID(guid)) {
    return;
  }
  const d = new Date();
  d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000));
  let expires = 'expires=' + d.toUTCString();
  document.cookie = APP_GUID + "=" + guid + ";" + expires + ";path=/";
}

export const getAppGuidCookie = () => {
  let name = APP_GUID + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const getAppSessionCookieHeader = () => {
  return '';
}